module.exports = __webpack_public_path__ + "static/img/downloadImg.1752d9f1.png";